import {Service, Application, HttpManager, Managers} from '@levelapp/softfabric';
import {NewInvestment} from "../Common/DTO/Investment";
import {getToken} from "../Common/Utils/token.utils";

export default class InvestmentsService extends Service
{
    httpClient = Application.current.resolve<HttpManager>(Managers.HTTP_MANAGER);
    auth: any = Application.current.resolve(Managers.AUTH_MANAGER);

    async createOne(investment: NewInvestment, callback: Function)
    {
        const token = getToken();
        this.httpClient.addCustomHeader("Authorization", `Bearer ${token}`);
        this.httpClient.post("api/investment", [], investment).then((response: any) =>
        {
            if (response !== undefined)
            {
                callback(response.data.data);
            }
        });
    }
}